
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate/agents/[[...location]]",
      function () {
        return require("private-next-pages/real-estate/agents/[[...location]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate/agents/[[...location]]"])
      });
    }
  